import { connect } from 'react-redux';
import { TextField, Button } from '@devfolioco/genesis';
import { isValidUsername } from '@devfolioco/helpers';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import debounce from 'lodash/debounce';
import styled from 'styled-components';
import React from 'react';

import { clearRegistrationError, checkUsernameAvailability, registerUser } from 'actions/registration';
import { ACTION_STATUS as STATUS } from '@constants';
import { ERRORS } from '@constants/errors';

const Flex = styled.div`
  display: flex;
`;

class SignUp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      _email: '',
      _password: '',
      _username: '',
      _firstName: '',
      _lastName: '',
    };

    this.checkUsernameDebounced = debounce(username => props.dispatchCheckUsernameAvailability(username), 250);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate(_, nextState) {
    const { error, dispatchClearErrors } = this.props;

    if (error && this.state !== nextState) {
      dispatchClearErrors();
    }
  }

  handleInputChange = ({ target }) => {
    const { name, value } = target;

    this.setState({ [name]: value }, () => {
      if (name === '_username' && value.trim().length >= 2) {
        this.checkUsernameDebounced(value);
      }
    });
  };

  checkUsernameAvailability = () => {
    const { _username } = this.state;

    const { dispatchCheckUsernameAvailability } = this.props;

    if (_username.length > 1) {
      dispatchCheckUsernameAvailability(_username);
    }
  };

  handleSubmit = event => {
    event.preventDefault();

    const { dispatchRegisterUser, error } = this.props;
    const { _email, _username, _password, _firstName, _lastName } = this.state;

    if (!error) {
      dispatchRegisterUser(_email, _username, _password, _firstName, _lastName);
    }
  };

  render() {
    const { error, isUsernameUnavailable, disabled, loading, registerUserStatus, preFields, postFields, requireName } =
      this.props;
    const { _username, _password } = this.state;

    const isUsernameInvalid = !isValidUsername(_username) && _username.length > 2;
    const isPasswordShort = _password.length > 0 && _password.length < 8;
    const isUsernameShort = _username.length > 0 && _username.length < 2;

    return (
      <form onSubmit={this.handleSubmit}>
        {preFields}
        {requireName && (
          <Flex>
            <TextField
              label="First Name"
              autoFocus={!preFields}
              maxLength="20"
              name="_firstName"
              onChange={this.handleInputChange}
              required
              type="text"
            />
            <TextField
              label="Last Name"
              appearance="normal"
              maxLength="20"
              name="_lastName"
              onChange={this.handleInputChange}
              required
              style={{ marginLeft: '20px' }}
              type="text"
            />
          </Flex>
        )}
        <TextField
          label="Email"
          name="_email"
          onChange={this.handleInputChange}
          required
          spellCheck={false}
          type="email"
          error={{
            [error]: error === ERRORS.emailDirty || error === ERRORS.emailUnavailable || error === ERRORS.emailInvalid,
          }}
        />

        <TextField
          label="Username"
          maxLength="15"
          name="_username"
          onChange={this.handleInputChange}
          placeholder=""
          required
          spellCheck={false}
          type="text"
          error={{
            [ERRORS.usernameShort]: isUsernameShort,
            [ERRORS.usernameNotAllowed]: isUsernameInvalid,
            [ERRORS.usernameUnavailable]: isUsernameUnavailable,
          }}
        />

        <TextField
          label="Password"
          name="_password"
          onChange={this.handleInputChange}
          placeholder=""
          required
          type="password"
          error={{
            [ERRORS.passwordShort]: isPasswordShort,
          }}
          instruction={!isPasswordShort && 'Minimum 8 characters'}
        />

        {postFields}

        <Button
          type="submit"
          size="large"
          stretch
          loading={registerUserStatus === STATUS.REQUEST || loading}
          disabled={disabled}
          style={{ marginTop: '2rem' }}
        >
          Sign up and continue
        </Button>
        <span
          style={{
            display: 'block',
            fontFamily: 'Nunito Sans',
            fontSize: 14,
            color: '#69757A',
            marginTop: 24,
            textAlign: 'center',
            opacity: 0.56,
          }}
        >
          By clicking Sign up, I agree to the <Link to="/privacy-policy">Privacy Policy</Link>
        </span>
      </form>
    );
  }
}

const mapStateToProps = ({ authentication, registration }) => ({
  authenticationError: authentication.error,
  email: registration.email,
  error: registration.error,
  isUsernameUnavailable: registration.isUsernameUnavailable,
  registerUserStatus: registration.status.registerUser,
});

const mapDispatchToProps = dispatch => ({
  dispatchClearErrors: () => {
    dispatch(clearRegistrationError());
  },
  dispatchCheckUsernameAvailability: username => {
    dispatch(checkUsernameAvailability(username));
  },
  dispatchRegisterUser: (email, username, password, firstName, lastName) => {
    dispatch(registerUser(email, username, password, firstName, lastName));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignUp));
